module.exports = __webpack_public_path__ + "static/media/b6.2e1c9b80.jpg";